<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-6">
        <div id="card-login-forgot" class="card card-shadow">
          <div class="card-login-forgot-inner">

            <div class="f-wrapper">
              <form v-on:keydown.enter="enterTriggerSignInOrSignUp">
                <div class="container">
                  <div class="row">
                    <div class="col-12 text-center">
                      <h2>{{$tr('forgotPassword.reset-password','Reset your password')}}</h2>
                      <p>{{$tr('forgotPassword.enter-email.send-instruction ','Enter your e-mail address and we will send you an instruction to change your password.')}}</p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="organizationNameControl">{{$tr('forgotPassword.org','Organization name')}}</label>
                        <div class="input-container">
                          <input
                              data-test-path="reset-password-organization"
                              type="text"
                              id="organizationNameControl"
                              class="form-control"
                              :placeholder="$tr('forgotPassword.org-enter','Enter organization name')"
                              v-model="form.organization"
                              ref="inputOrganization"
                              @keyup="organizationValidator.validateDelayed()"
                              @focusout="organizationValidator.validate()"
                          >
                          <b-spinner v-if="organizationValidator.validationInProgress" variant="primary" label="Spinning"></b-spinner>
                        </div>
                        <div class="validator-messages">
                          <small v-if="!organizationValidator.isValid" class="text-danger"> {{ organizationValidator.errorMessage }}</small>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="loginControl">{{$tr('forgotPassword.email','Email address')}}</label>
                        <div class="input-container">
                          <input
                              data-test-path="reset-password-login"
                              type="text"
                              id="loginControl"
                              class="form-control"
                              @focusout="emailValidator.validate()"
                              @keyup="emailValidator.validateDelayed()"
                              ref="inputEmail"
                              v-model="form.email"
                              :placeholder="$tr('forgotPassword.email-enter','Enter email')"
                          >
                          <b-spinner v-if="emailValidator.validationInProgress" variant="primary" label="Spinning"></b-spinner>
                        </div>
                        <div class="validator-messages">
                          <small v-if="!emailValidator.isValid" class="text-danger"> {{ emailValidator.errorMessage }}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 d-flex f-justify-end">
                      <button
                          type="button"
                          class="btn btn-primary"
                          data-test-path="create-password-token-btn"
                          :disabled="this.form.organization === '' || this.form.email === '' || !this.organizationValidator.isValid || !this.emailValidator.isValid"
                          @click="resetPassword()">
                        {{$tr('forgotPassword.reset-password-button','Reset Password')}}</button>
                    </div>
                  </div>

                </div>
              </form>
            </div>

            <div v-if="organizationInfo && organizationInfo.urlLoginPageImage && organizationInfo.urlLoginPageImage.url && loading === false" class="container bottom-container">
              <div class="row">
                <div class="col-12 organization-image">
                  <img v-if="organizationInfo.urlLoginPageImage.url" class="img-fluid" :src="organizationInfo.urlLoginPageImage.url" alt="">
                  <h4 v-else class="organization-name mb-0">{{organizationInfo.name}}</h4>
                </div>
              </div>
            </div>

            <div  class="container bottom-container">
              <div v-if="!organizationInfo && loading === false" class="row">
                <div class="col-12 text-center">

                  <button data-test-path="go-back-to-sign-in" @click="switchMode()" class="switch-mode-btn">
                    <span>{{$tr('forgotPassword.back-signIn','Back to Sign In')}}</span>
                  </button>
                </div>
              </div>
              <div v-if="organizationInfo && organizationInfo.urlLoginPageImage && organizationInfo.urlLoginPageImage.url && loading === false" class="row">
                <div class="col-12 organization-image">
                  <img v-if="organizationInfo.urlLoginPageImage.url" class="img-fluid" :src="organizationInfo.urlLoginPageImage.url" alt="">
                  <h4 v-else class="organization-name mb-0">{{organizationInfo.name}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  <b-container class="px-0" >-->
<!--    <b-row no-gutters>-->
<!--      <b-col class="pt-5">-->
<!--        <b-card header-tag="header" >-->
<!--          <template v-slot:header>-->
<!--            <h6 class="mb-0">Reset your password</h6>-->
<!--          </template>-->
<!--          <template>-->
<!--            <h4 class="text-center mb-4">Enter your e-mail address and we will send you an instruction to change your password.</h4>-->
<!--          </template>-->
<!--          <b-card-text>-->
<!--            <h2 class="text-center" v-if="organizationInfo">{{organizationInfo.fullName}}</h2>-->
<!--            <ImageViewer-->
<!--                v-if="organizationInfo && organizationInfo.urlLoginPageImage && organizationInfo.urlLoginPageImage.url"-->
<!--                :min-height="300"-->
<!--                :max-height="300"-->
<!--                :max-width="300"-->
<!--                :src="organizationInfo.urlLoginPageImage.url"-->
<!--                class="mb-3 img-fluid"-->
<!--            >-->
<!--            </ImageViewer>-->

<!--            <b-form v-on:keydown.enter="enterTriggerSignInOrSignUp">-->

<!--              <b-form-group-->
<!--                  v-if="!organizationInfo"-->
<!--                  label="Organization name:"-->
<!--                  :state="organizationValidator.isValid"-->
<!--                  :invalid-feedback="organizationValidator.errorMessage"-->
<!--              >-->
<!--                <b-container>-->
<!--                  <b-row>-->
<!--                    <b-col class="p-0">-->
<!--                      <b-form-input-->
<!--                          @focusout="organizationValidator.validate()"-->
<!--                          @keyup="organizationValidator.validateDelayed()"-->
<!--                          ref="inputOrganization"-->
<!--                          v-model="form.organization"-->
<!--                          type="text"-->
<!--                          placeholder="Enter organization name"-->
<!--                      ></b-form-input>-->
<!--                    </b-col>-->
<!--                    <b-col cols="auto" class="pr-0 pl-2">-->
<!--                      <transition name="fade">-->
<!--                        <b-spinner v-if="organizationValidator.validationInProgress" variant="primary"-->
<!--                                   label="Spinning"></b-spinner>-->
<!--                      </transition>-->
<!--                      <div class="fixed-width-36"></div>-->
<!--                    </b-col>-->
<!--                  </b-row>-->
<!--                </b-container>-->
<!--              </b-form-group>-->

<!--              <b-form-group-->
<!--                  label="Email address:"-->
<!--                  :state="emailValidator.isValid"-->
<!--                  :invalid-feedback="emailValidator.errorMessage"-->
<!--              >-->
<!--                <b-container>-->
<!--                  <b-row>-->
<!--                    <b-col class="p-0">-->
<!--                      <b-form-input-->
<!--                          @focusout="emailValidator.validate()"-->
<!--                          @keyup="emailValidator.validateDelayed()"-->
<!--                          ref="inputEmail"-->
<!--                          v-model="form.email"-->
<!--                          type="text"-->
<!--                          placeholder="Enter email"-->
<!--                      ></b-form-input>-->
<!--                    </b-col>-->
<!--                    <b-col cols="auto" class="pr-0 pl-2">-->
<!--                      <transition name="fade">-->
<!--                        <b-spinner v-if="emailValidator.validationInProgress" variant="primary"-->
<!--                                   label="Spinning"></b-spinner>-->
<!--                      </transition>-->
<!--                      <div class="fixed-width-36"></div>-->
<!--                    </b-col>-->
<!--                  </b-row>-->
<!--                </b-container>-->
<!--              </b-form-group>-->

<!--            </b-form>-->
<!--          </b-card-text>-->

<!--          <b-button-->
<!--              data-test-path="create-password-token-btn"-->
<!--              :disabled="this.form.organization === '' || this.form.email === '' || !this.organizationValidator.isValid || !this.emailValidator.isValid"-->
<!--              variant="plm-primary" @click="resetPassword()">Reset my password-->
<!--          </b-button>-->
<!--        </b-card>-->
<!--      </b-col>-->
<!--    </b-row>-->
<!--  </b-container>-->
</template>

<script>

import Rpc from '@/Rpc';
import FieldValidator from '@/validation/FieldValidator';
import ImageViewer from "@/components/img/ImageViewer";



export default {
  name: "ForgotPassword",
  components: {ImageViewer},

  created() {

    this.organizationValidator.
    withOwningComponent(this).
    withStateGetter(() => [this.form.organization]).
    withLabel($tr("organizationNameP","Organization name")).
    withValidationFunction(() =>  Rpc.Session.validateOrganizationNameForgotPassword(this.form.organization));

    this.emailValidator.
    withOwningComponent(this).
    withStateGetter(() => [this.form.email]).
    withLabel($tr("email","Email")).
    withValidationFunction(() => Rpc.Session.validateRegistrationEmail(this.form.email));

  },

  beforeMount() {
    this.form.email = window.localStorage.getItem('email');
    this.form.organization = window.localStorage.getItem('organization');
  },

  async mounted() {
    await this.extractDomainName();
    this.focusInput();
  },

  methods: {

    switchMode() {
      this.$router.push('/');
    },

    async extractDomainName() {
      let domain = window.location.hostname
      this.organizationInfo =  await Rpc.Session.extractOrganizationFromDomain(domain);
      if(this.organizationInfo){
        this.form.organization = this.organizationInfo.name;
      }
      this.loading = false;
    },


    enterTriggerSignInOrSignUp(event) {
      if (event.key === 'Enter') {
        this.resetPassword();
      }
    },

    focusInput(){
      if(!this.form.organization && !this.organizationInfo){
        this.$refs.inputOrganization.focus();
      }
    },


    async resetPassword(){
      await DialogManager.info($tr('forgotPassword.reset-password-dialog','Reset password'),
          $tr('forgotPassword.info-email-send-instructions','Thank you, if your e-mail address is in our ' +
              'database, we will send you an e-mail with instructions to change your password.'));
      await Rpc.Users.forgotPassword(this.form.organization, this.form.email);
      setTimeout(() =>{window.isCordova?window.location.href=window.cordovaUrl+"/dashboard":window.location.href="/dashboard" }, 2000);
    },

    async reValidate() {
      await Promise.all([
        this.organizationValidator.validate(),
        this.emailValidator.validate(),
      ])
    },
  },

  data: () => ({
    loading: true,
    organizationValidator: new FieldValidator(),
    emailValidator: new FieldValidator(),
    organizationInfo: null,
    form: {
      organization: '',
      email: '',
    }
  })
}

</script>

<style lang="sass">

  @import "../styles/card.sass"
  @import '../styles/signin-signup'
  @import "../styles/login-forgot"

  .switch-mode-btn
    background: transparent
    border: 1px solid black
    font-weight: bold
    border-radius: 25px
    padding: 5px 15px

</style>